import { render, staticRenderFns } from "./DefectGroupInteriorV1Input.vue?vue&type=template&id=63428a9d&scoped=true"
import script from "./DefectGroupInteriorV1Input.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefectGroupInteriorV1Input.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DefectGroupInteriorV1Input.vue?vue&type=style&index=0&id=63428a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63428a9d",
  null
  
)

export default component.exports